import type { RecentSwap, RecentSwapProgressStep, RecentSwapStepView } from './contracts'

const transactionType = (step: RecentSwapProgressStep): string => {
  if (step.type === 'usdt_to_ton') return 'swap_usdt_ton'
  if (step.type === 'ton_to_spotty') return 'swap_ton_spotty'
  return step.type
}

const chainType = (step: RecentSwapProgressStep, swap: RecentSwap): string => {
  if (step.type === 'jupiter_swap') return 'solana'
  if (step.type === 'bridge') {
    if (step.provider === 'symbiosis') return 'evm'
    if (step.provider === 'layerswap' || step.provider === 'rango') return 'solana'
    return swap.source_chain_type === 'solana' ? 'solana' : 'evm'
  }
  return 'ton'
}

const displayStatus = (step: RecentSwapProgressStep): string => {
  if (step.status === 'completed') return 'completed'
  if (step.status === 'failed') return 'failed'
  if (['submitted', 'reconciling', 'awaiting_user'].includes(step.status)) return 'active'
  return 'pending'
}

const chainId = (step: RecentSwapProgressStep, swap: RecentSwap): number | null => {
  if (Object.prototype.hasOwnProperty.call(step, 'chain_id')) return step.chain_id ?? null
  if (chainType(step, swap) === 'ton') return null
  return swap.source_chain_type === 'evm' ? swap.source_chain_id : null
}

const firstAmount = (...values: (string | null | undefined)[]): string =>
  values.find((value) => !!value) ?? ''

export const presentSwapSteps = (swap: RecentSwap): RecentSwapStepView[] => {
  let previousEconomicOutput = swap.source_amount
  return swap.progress.steps.map((step) => {
    const inputAmount = firstAmount(step.input_amount, previousEconomicOutput)
    const settledOutput = step.settled_amount ?? ''
    const expectedOutput = step.expected_amount
    previousEconomicOutput = firstAmount(settledOutput, expectedOutput, previousEconomicOutput)
    return {
      id: step.step_id,
      tx_type: transactionType(step),
      tx_hash: step.transaction_id ?? '',
      chain_type: chainType(step, swap),
      chain_id: chainId(step, swap),
      provider: step.provider,
      status: displayStatus(step),
      amount_in: inputAmount,
      amount_out: settledOutput,
      amount_in_expected: firstAmount(step.input_amount, inputAmount),
      amount_out_expected: expectedOutput,
      started_at: step.created_at,
      completed_at: step.completed_at ?? null,
      created_at: step.created_at,
    }
  })
}
